import classes from "./NavBar.module.css";
import logo from "../../img/NavBarImg/Logo.png";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../../firebase/firebase";
import { isUnverifiedPasswordUser } from "../../firebase/authVerification";

function NavBar({ onLoginClick, onSignupClick }) {
  const [user, setUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false); // חדש

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(isUnverifiedPasswordUser(currentUser) ? null : currentUser);
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
  };

  return (
    <div className={classes.nav_bar}>
      <nav className={classes.nav} aria-label="ניווט ראשי">
        <div className={classes.logo}>
          <Link to="/">
            <img src={logo} alt="Tabufy - המרת נסח טאבו לאקסל" />
          </Link>
        </div>

        {/* כפתור המבורגר */}
        <button
          className={classes.hamburger}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="פתח תפריט ניווט"
          aria-expanded={menuOpen}
        >
          ☰
        </button>

        {/* תפריט */}
        <ul className={menuOpen ? classes.open : ""}>
          <li><Link to="/upload-tabu">שירות ההמרה</Link></li>
          {/* TODO: Uncomment to show השוואת נסחים in navbar */}
          {/* <li><Link to="/compare">השוואת נסחים</Link></li> */}
          <li><Link to="/plans">מסלולים</Link></li>
          <li><Link to="/faq">שאלות נפוצות</Link></li>
          {/* <li><Link to="/contact">צור קשר</Link></li> */}
          {user && (
            <li>
              <Link to="/account" className={classes.nav_link}>
                אזור אישי
              </Link>
            </li>
          )}
        </ul>
      </nav>

      {user ? (
        <button className={classes.login_button} onClick={handleLogout}>
          התנתק
        </button>
      ) : (
        <div className={classes.buttons}>
          <button onClick={onLoginClick} className={classes.login_button}>
            כניסה
          </button>
          <button onClick={onSignupClick} className={classes.register_button}>
            הרשמה
          </button>
        </div>
      )}
    </div>
  );
}

export default NavBar;
